<template>

  <div class="driver-summary-top" :style="{height:contentHeight+'px'}">
      <div class="driver-summary-top-left-item">
        <span class="label">司机ID</span>
        <span class="val">{{model.id}}</span>
      </div>
      <div class="driver-summary-top-left-item">
        <span class="label">年龄</span>
        <span class="val">{{getAge()}}</span>
      </div>
      <div class="driver-summary-top-left-item">
        <span class="label">驾龄</span>
        <span class="val">{{getJl()}}</span>
      </div>
    <div class="driver-summary-top-left-item">
      <span class="label">人证</span>
      <span class="val">{{getLicense()}}</span>
    </div>
  </div>
</template>

<script>


  export default {
    name: 'DriverInfoTopNew',
    props: {
      disabled:{
        type:Boolean,
        default:true
      },
      model:{
        type:Object,
        default:{}
      }
    },
  data(){
      return {
        contentHeight:document.documentElement.clientHeight-200
      }
  },methods:{
      edit(){
        this.$emit('update:disabled', false);
      },save(){
        this.$emit('change');
      },getAge(){
        if(!this.model.idNumber){
          return '-';
        }
        let year = new Date().getFullYear();
        let cs = this.model.idNumber.substring(6,10);
        let age = year -cs;
        return age;
      },getJl(){
        if(this.model.license && this.model.license.firstReviceDate){
          let year = new Date().getFullYear();
          let cs = this.model.license.firstReviceDate.substring(0,4);
          let age = year -cs;
          return age+"年";
        }
        return '-';
      },getLicense(){
        let lable = '无';
        if(this.model.personLicense&&this.model.personLicense.licenseFlag){
          lable = '有';
        }
        return lable;
      }
    }
  }
</script>
<style lang="less" scoped>


  .driver-summary-top{
    background: #fff;
    border-radius: 12px;
    margin-top: 24px;
    padding: 24px;
  }

  .driver-summary-top  .driver-summary-top-left-item{
    flex:1;
    display: flex;
    gap: 8px;
    align-items: center;
    padding-bottom: 24px;
  }
  .driver-summary-top-left-item .label{
    color: rgba(145, 146, 158, 1);
    font-size: 16px;
  }
  .driver-summary-top-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
  }
  .driver-summary-top-left-item img{
    width: 16px;
    height: 16px;
    margin-left: 30px;
  }
  .driver-summary-top-left-item .time{
    font-size: 12px;
    font-weight: 400;
    color: rgba(63, 140, 255, 1);
  }
  .driver-summary-top-btn{
    width: 145px;
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: rgba(63, 140, 255, 1);
  }
  .driver-summary-top-btn img{
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

</style>